import { combineReducers } from "redux";
import { sessionReducer } from "redux-react-session";

// Reducers
import notificationReducer from "hooks/notification";
import notificationCenterReducer from "../../hooks/notification-center";
import automationCenterReducer from "../../hooks/automation";
import formDataReducer from "hooks/dataOfForm";
import exportFormReducer from "hooks/exportForm";
import reportReducer from "../../hooks/report";
import userReducer from "../../hooks/user";
import themeReducer from "../../hooks/theme";

const rootReducer = combineReducers({
    session: sessionReducer,
    records: formDataReducer,
    exportRecords: exportFormReducer,
    notification: notificationReducer,
    notificationCenter: notificationCenterReducer,
    automation: automationCenterReducer,
    report: reportReducer,
    user: userReducer,
    theme: themeReducer
});

export default rootReducer;
